import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    WucButtonModule,
    WucLinkModule,
    WucListModule,
    WucNavigationItemModule,
    WucNavigationModule,
    WucRackModule,
} from '@inshared/website-ui-components';
import { AuthorizeBeforeRedirectModule } from '@inshared/shared/util-directives';
import { NavigationComponent } from './navigation.component';

@NgModule({
    imports: [
        AuthorizeBeforeRedirectModule,
        CommonModule,
        WucButtonModule,
        WucLinkModule,
        WucListModule,
        WucNavigationItemModule,
        WucNavigationModule,
        WucRackModule,
    ],
    exports: [NavigationComponent],
    declarations: [NavigationComponent],
})
export class NavigationModule {}
